import { ApolloCache, FetchResult, InternalRefetchQueryDescriptor, useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert, Row, Col, Label } from 'reactstrap';
import { ADD_OTHER_ORG, GET_CATEGORIES,  GET_CHILD_ORGS,  GET_ORG_RELATIONSHIPS, HAS_CLONED_DESCENDANT } from '../../../graphql/org-gql';
import { IOrg, ICategory, isCategory, isTopOrg } from '../../../types/org';
import { useEffect, useState } from "react";
import { messages } from "../../../i18n/message";
import { LOCALES } from "../../../i18n/locales";
import { IValueListLight } from "../../../types/valuelist";
import { ORG_VALUE_LISTS } from "../../../graphql/valuelist-gql";
import OrgTree from "../../common/org-tree/org-tree";
import { notifyError, notifySuccess } from "../../../services/notification";
import React from "react";
import { AddIcon, CancelIcon } from "../../common/icons";
import Select from "../../common/select/select";
import SpinnerOverlay from "../../common/spinner/spinner";
import { Action } from "../../../types/individual";
import useAuth from "../../../hook/useAuth";
import confirm from "../../common/confirm";
import Button from "../../common/button";

type OrgCreateOtherProps = {
    parentOrg: IOrg,
    isOpen: boolean,
    toggle: () => void
}

const OrgCreateOtherModal = (props: OrgCreateOtherProps) => {
    const { parentOrg, isOpen, toggle } = props
    const locale = LOCALES.ENGLISH;
    const [relTypeId, setRelTypeId] = useState<number>(0)
    const [selectedOrg, setSelectedOrg] = useState<IOrg|ICategory>();
    const [msg,setMsg] =  useState<string>('');
    //const [selectedOrgHasClonedDescendant,setSelectedOrgHasClonedDescendant] = useState<boolean>(false);
    const [addOtherOrg,{loading:addLoading}] = useMutation(ADD_OTHER_ORG)
    const {loading:callHasClonedDescendantLoading,data:hasClonedDescendantData}=useQuery(HAS_CLONED_DESCENDANT,{variables:{orgId:parentOrg.id},fetchPolicy:'network-only',
        onCompleted: (data) => {
            //console.log("hasClonedDescendantData:",data);
        }}
    )
    //const [callSelectedOrgHasClonedDescendant,{loading:callSelectedOrgHasClonedDescendantLoading}]=useLazyQuery(HAS_CLONED_DESCENDANT)
    const [relTypes,setRelTypes]= useState<IValueListLight[]>([]);
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const { categories } = client.readQuery({query: GET_CATEGORIES})
    const {isAdmin} = useAuth();

    useEffect(()=>{
        if(isAdmin)
            setRelTypes(orgValueLists.otherOrgOrgRelTypes)
        else
            setRelTypes(orgValueLists.otherOrgOrgRelTypes.filter((item:IValueListLight)=>item.code!=='SHARE'))

    },[orgValueLists,isAdmin])

    useEffect(()=>{
        let msg=''
        if(relTypeId!==0){
            msg = relTypeValidate()||'';
        }
        if(selectedOrg){
            msg =msg? (msg+'<br/>'+ destOrgValidate()):destOrgValidate();
        }
        setMsg(msg)

    },[relTypeId,hasClonedDescendantData,relTypes,selectedOrg])

    /*useEffect(()=>{
        //console.log("selectedOrg:",selectedOrg)
        if(selectedOrg){
            callSelectedOrgHasClonedDescendant({variables:{orgId:selectedOrg?.id}}).then((response:any)=>{
                //console.log("response:",response)
                setSelectedOrgHasClonedDescendant(response.data?.hasClonedDescendant)
            })
        }
    },[selectedOrg])*/

    const destOrgValidate= ()=>{
        
        if(selectedOrg?.id===parentOrg.id) {
            return messages[locale].ERROR['2.1']
        } else if(isCategory(selectedOrg)) {
            return messages[locale].ERROR['2.14']
        } else if(selectedOrg?.id===parentOrg?.parentOrg?.id||parentOrg.id===selectedOrg?.parentOrg?.id) {
            return messages[locale].ERROR['2.13']
        } else {
            return ''
        }
    }

    const relTypeValidate=()=>{
        const valueList:IValueListLight|undefined = relTypes.find((item: IValueListLight)=>Number(item.id)===Math.abs(relTypeId||0))
        
        //console.log("isTopOrg(selectedOrg):",isTopOrg(selectedOrg))
        //console.log("isTopOrg(parentOrg):",isTopOrg(parentOrg))
        //console.log("parentOrg:",parentOrg)
        //console.log("selectedOrg:",selectedOrg)
        if(valueList?.code === 'SHARE'&&relTypeId<0&&hasClonedDescendantData.hasClonedDescendant){
            return messages[locale].ERROR['2.3']
        }/*else if(valueList.code === 'SHARE'&&relTypeId>0&&selectedOrgHasClonedDescendant){
            return messages[locale].ERROR['2.3']
        }*/else if(valueList?.code === 'SHARE'&&relTypeId<0&&isTopOrg(parentOrg)){
            return messages[locale].ERROR['2.4']
        }else if(valueList?.code === 'SHARE'&&relTypeId>0&&isTopOrg(selectedOrg)){
            return messages[locale].ERROR['2.4']
        }else{
            return '';
        }
    }

    const onSelectOrg = (org?: IOrg | ICategory) => {
        setSelectedOrg(org);
    }

    const onChangeRelType = (event: any) => {
        setRelTypeId(event.target.value);
        
    }

    const addValidationConfirm = (message:string) => {
        return confirm({
            title: 'Cannot Create Relationship',
            content: message,
            okText: <><CancelIcon/> Close</>,
            okBtnColor: 'primary',
            titleCenter: true,
            bodyCenter: true,
            showCancel:false
        })
    }

    const onAddOtherOrg = () => {
        if(parentOrg?.id && selectedOrg?.id && relTypeId)
            //console.log({orgId: parentOrg.id,otherOrgId: selectedOrg.id,relTypeId: relTypeId})
            addOtherOrg({
                variables: {
                    orgId: parentOrg.id,
                    action: Action.ADD_RELATIONSHIP_VALIDATION,
                    input:{orgId: parentOrg.id,otherOrgId: selectedOrg.id,relTypeId: relTypeId}
                },
                onCompleted: (data) => {
                    toggle()               
                    if(data?.addOtherOrg.success) {
                        addOtherOrg({
                            variables: {
                                orgId: parentOrg.id,
                                action: Action.ADD_RELATIONSHIP,
                                input:{orgId: parentOrg.id,otherOrgId: selectedOrg.id,relTypeId: relTypeId}
                            },
                            refetchQueries: getRefetchQuery(),
                            awaitRefetchQueries: true,
                            update(cache,{data}){updateCache(cache,data,relTypeId,parentOrg,selectedOrg)},
                            onCompleted: (data) => {
                                if(data?.addOtherOrg.success) {
                                    notifySuccess()
                                }else if(data.addOtherOrg?.message){
                                    addValidationConfirm(data.addOtherOrg.message);
                                }
                            }
                        })
                    }else if(data?.addOtherOrg.message) 
                        addValidationConfirm(data.addOtherOrg.message);
                }
            })
    }

    const updateCache = (cache : ApolloCache <any>, result: any,relTypeId:number,parentOrg:IOrg,selectedOrg:ICategory|IOrg|undefined) => {
        const valueList:IValueListLight|undefined = relTypes.find((item: IValueListLight)=>Number(item.id)===Math.abs(relTypeId||0))
        if(valueList?.code === 'SHARE'){
            const toOrgId = relTypeId>0?parentOrg.id:(selectedOrg?.id)
            // update hasChild for toOrg
            cache.modify({
                id: `Org:${toOrgId}`,
                fields: {
                    hasChild() {
                        return true;
                    }
                }
            })

        }

    }

    const getRefetchQuery = () => {
        let query:any=[]
        
        if (parentOrg?.id) {
            query = [...query,{query: GET_ORG_RELATIONSHIPS, variables: { orgId: parentOrg.id }}]
        }
        if (selectedOrg?.id) {
            query = [...query,{query: GET_ORG_RELATIONSHIPS, variables: { orgId: selectedOrg.id }}]
        }
        const valueList:IValueListLight|undefined = relTypes.find((item: IValueListLight)=>Number(item.id)===Math.abs(relTypeId||0))
        //console.log("valueList:",valueList)
        if(valueList?.code === 'SHARE'){
            //console.log("relTypeId:",relTypeId)
            const toOrgId = relTypeId>0?parentOrg.id:(selectedOrg?.id)
            if(toOrgId)
                query = [...query,{query:GET_CHILD_ORGS,variables:{id:toOrgId}}]
        }/*else if(valueList?.code === 'DIRECT'){
            if(parentOrg.sharedToOrgIds){
                const orgIdList = parentOrg.sharedToOrgIds.split(',').map(item => item.trim());
                orgIdList.forEach(id=>query = [...query,{query:GET_CHILD_ORGS,variables:{id}}])
            }
        }*/

        console.log("query:",query)
        
        return query;
    }

    const onCancel=()=>{toggle();}

    useEffect(()=>{
        setSelectedOrg(undefined);
        setMsg('')
        setRelTypeId(0);
    },[isOpen])

    return (
        <>
        {(addLoading || callHasClonedDescendantLoading) && <SpinnerOverlay/>}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Create Relationship to Other Organization</ModalHeader>
            <ModalBody>
            {msg&& <Alert color="danger" style={{margin:'0px'}}><div dangerouslySetInnerHTML={{__html:msg}}></div></Alert>}
            {/*<Alert color="info" style={{margin:'0px'}}><b>Please note:<br/> </b>Selected organization has a cloned child organization and cannot be shared.</Alert>*/}
            <Row>
                <p>Please select a relationship type you would like to create and which organization you want to create that relationship with.</p>
            </Row>
            <Row>
                <Col md={4}><Label for="relType" aria-label="relationship type">Relationship Type: (required)</Label></Col>
                <Col md={8}>
                    <Select id="relType"  value={relTypeId} onChange={onChangeRelType} style={{width:'100%'}} autoFocus={true}>
                        <option key={0} value={0}>Select a relationship type...</option>
                        {relTypes.map((item: IValueListLight) => {return(<React.Fragment key={item.id+'main'}>
                            <option key={item.id} value={item.id}>{item.label}</option>
                            <option key={item.id+'down'} value={-item.id} style={{fontStyle:"italic"}}>{item.label2}</option>
                        </React.Fragment>)})}
                    </Select>
                </Col>
            </Row>
            <div className='row' style={{maxHeight:'350px',overflowY:"auto",border: '1px solid var(--bs-border-color-translucent)',margin:'1px',padding:'5px'}}>
                <OrgTree roots={categories || []} isGlobal={false} onSelected={onSelectOrg}></OrgTree>
            </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onAddOtherOrg} disabled={relTypeId===0||msg!==''||selectedOrg===undefined}><AddIcon/> Create</Button>
                <Button color="secondary" onClick={onCancel}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default OrgCreateOtherModal;
